module.exports = __webpack_public_path__ + "img/Boy_020006.ab2d99a9.png";